import React from "react";
import Navbar from "../components/derma/Navbar";
import Hero from "../components/derma/Hero";
import Difference from "../components/derma/Difference";
import Treatments from "../components/derma/Treatments";
import Testimonials from "../components/derma/Testimonials";
import About from "../components/derma/About";
import BookingSection from "../components/derma/BookingSection";
import ContactSection from "../components/derma/ContactSection";
import Footer from "../components/derma/Footer";

export default function DermaSite() {
  return (
    <main className="min-h-screen bg-[#FDFBF7] text-[#2D2926] overflow-x-hidden" data-testid="derma-site">
      <Navbar />
      <Hero />
      <Difference />
      <About />
      <Treatments />
      <Testimonials />
      <BookingSection />
      <ContactSection />
      <Footer />
    </main>
  );
}
